import { render } from "./July4th2022.vue?vue&type=template&id=d3ae3542&ts=true"
import script from "./July4th2022.vue?vue&type=script&lang=ts"
export * from "./July4th2022.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__